module.exports = __webpack_public_path__ + "img/error.d44fdc0d.png";